import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { timeout, map } from "rxjs/operators";

const mainUrl = environment.url;

@Injectable({
  providedIn: "root",
})
export class InsurancePolicyService {
  constructor(private http: HttpClient) {}

  getAllInsurancePoliciesPaged(page, size): Observable<any> {
    return this.http.get(mainUrl + `mother-policy/paged?page=${page}&size=${size}&sort=createdAt,desc`).pipe(
      timeout(30000),
      map((res: any) => res.data)
    );
  }

  async getInsurancePolicyById(id): Promise<any> {
    return this.http.get(mainUrl + `mother-policy/${id}`).toPromise();
  }

  createInsurancePolicy(form): Observable<any> {
    return this.http.post(mainUrl + "mother-policy", form).pipe(map((res: any) => res.data));
  }

  editInsurancePolicy(form, id): Observable<any> {
    return this.http.put(mainUrl + `mother-policy/${id}`, form).pipe(map((res: any) => res.data));
  }

  deleteInsurancePolicy(id): Observable<any> {
    return this.http.delete(mainUrl + `mother-policy/${id}`).pipe(
      timeout(30000),
      map((res: any) => res.data)
    );
  }

  getNextExpirationPolicy(data): Observable<any> {
    return this.http.post(mainUrl + `mother-policy/expired`, data).pipe(
      timeout(30000),
      map((res: any) => res)
    );
  }

  getMotherPolicyExpiredReportsToExcel(data) {
    return this.http.post(mainUrl + "mother-policy/expired-excel", data, { reportProgress: true, observe: "response", responseType: "blob" }).pipe(
      map((res: any) => {
        return res.body;
      })
    );
  }

  getPoliciesByFinalUser(): Observable<any> {
    return this.http.get(mainUrl + `dispatch`).pipe(
      timeout(30000),
      map((res: any) => res.data)
    );
  }

  getPolicyImage(id): Observable<any> {
    return this.http.get(mainUrl + `files/${id}`).pipe(
      timeout(10000),
      map((res: any) => res?.data?.file)
    );
  }

  getPolicyDetailsById(id): Observable<any> {
    return this.http.get(mainUrl + `dispatch/mother-policy/${id}/details`).pipe(
      timeout(120000),
      map((res: any) => res.data)
    );
  }

  getPolicyReport(): Observable<any> {
    return this.http.post(mainUrl + `mother-policy/report`, {}, { reportProgress: true, observe: "response", responseType: "blob" }).pipe(
      timeout(60000),
      map((res: any) => res.body)
    );
  }

  getOperationsByPolicyId(id, type): Observable<any> {
    return this.http.get(mainUrl + `mother-policy/${id}/merchantype/${type}`).pipe(
      timeout(60000),
      map((res: any) => res.data)
    );
  }

  getMediaByPolicyId(id, type, operationId): Observable<any> {
    return this.http.get(mainUrl + `mother-policy/${id}/merchantype/${type}/operation/${operationId}`).pipe(
      timeout(60000),
      map((res: any) => res.data)
    );
  }

  getHeader() {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: window.localStorage.getItem("token"),
    });

    return headers;
  }
}
